import { useLayoutEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Video from "../components/Video";
import { SHOWREEL } from "../data/site";

const PANELS = [
  { src: SHOWREEL[0], tag: "MOTION" },
  { src: SHOWREEL[1], tag: "TALKING HEAD" },
  { src: SHOWREEL[2], tag: "VSL" },
  { src: SHOWREEL[3], tag: "FACELESS" },
  { src: SHOWREEL[4], tag: "MOTION" },
  { src: SHOWREEL[5], tag: "SHORT-FORM" },
];

export default function Showreel() {
  const ref = useRef(null);
  const stripRef = useRef(null);
  const [distance, setDistance] = useState(1200);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });
  const x = useTransform(scrollYProgress, [0, 1], [0, -distance]);

  useLayoutEffect(() => {
    const measure = () => {
      if (!stripRef.current) return;
      const d = stripRef.current.scrollWidth - window.innerWidth + 80;
      setDistance(Math.max(0, d));
    };
    measure();
    window.addEventListener("resize", measure);
    const t = setTimeout(measure, 600);
    return () => {
      window.removeEventListener("resize", measure);
      clearTimeout(t);
    };
  }, []);

  return (
    <section ref={ref} id="showreel" className="relative h-[360vh]" data-testid="showreel">
      <div className="sticky top-0 flex h-[100svh] flex-col justify-center overflow-hidden">
        <div className="pointer-events-none absolute left-6 top-[12%] z-20 md:left-16">
          <p className="label text-lav-400">02 — SHOWREEL</p>
          <h2 className="text-huge uppercase mt-3">
            WORK THAT
            <br />
            MOVES.
          </h2>
        </div>

        <motion.div
          ref={stripRef}
          style={{ x }}
          className="flex items-center gap-[3vw] pl-6 md:pl-16 will-change-transform"
        >
          {PANELS.map((p, i) => (
            <div
              key={i}
              className="group relative aspect-[9/16] h-[62vh] shrink-0"
            >
              <Video
                src={p.src}
                cursor="WATCH"
                priority={i < 2}
                className="h-full w-full ring-1 ring-white/5 transition-[transform,box-shadow] duration-500 group-hover:scale-[1.02] group-hover:ring-lav-400/70 group-hover:shadow-[0_0_80px_-20px_rgba(167,139,250,0.6)]"
              />
              <div className="pointer-events-none absolute bottom-0 left-0 flex w-full items-end justify-between p-4">
                <span className="label text-white/80">{p.tag}</span>
                <span className="label text-white/40">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            </div>
          ))}
          <div className="flex h-[62vh] shrink-0 items-center pr-[10vw] pl-[4vw]">
            <span className="text-big uppercase text-white/20">END OF REEL</span>
          </div>
        </motion.div>

        <div className="pointer-events-none absolute bottom-8 left-1/2 -translate-x-1/2 label text-white/30">
          SCRUB THE TIMELINE — SCROLL
        </div>
      </div>
    </section>
  );
}
